var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"zg-quote"},[_c('p',[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('div',{staticClass:"zg-quote__arrow"},[_c('zg-icon',{attrs:{"icon":"tooltip-arrow","color":"beige"}})],1)]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }